<template>
  <div v-if="isReviewStatusGot">
    <!-- USER MENU -->
    <UserMenu v-if="!isAdmin && !isPm && !isHr && !isSales" />
     
    <!-- HR -->
    <HrMenu v-if="isHr && !isAdmin" />

    <!-- SALES MENU -->
    <SalesMenu v-if="(isSales && !isAdmin)" />

    <!-- PM MENU -->
    <PmMenu v-if="(isPm && !isAdmin && !isSales)" />

    <!-- ADMIN MENU -->
    <AdminMenu v-if="isAdmin" />
  </div>
</template>

<script>
import AdminMenu from './Sidebar/AdminMenu.vue';
import PmMenu from './Sidebar/PmMenu.vue';
import SalesMenu from './Sidebar/SalesMenu.vue';
import HrMenu from './Sidebar/HrMenu.vue';
import UserMenu from './Sidebar/UserMenu.vue';


export default {
  name: 'AppSidebarNav',
  components: {
    UserMenu,
    AdminMenu,
    PmMenu,
    SalesMenu,
    HrMenu
  },
  emits: ['toggleModal'],
  mounted() {
    this.$store.dispatch('teams/getReviewStatus')
  },
  data() {
    return {}
  },
  computed: {
    isRecruiter() {
      const user = this.$store.getters['authorization/getCurrentUser']
      return user && user.roles && Array.isArray(user.roles) && user.roles.some((obj => obj && obj.id === 14))
    },

    isAdmin() {
      const user = this.$store.getters['authorization/getCurrentUser']
      return user && user.role && user.role.name === 'admin'
    },

    isPm() {
      return this.$store.getters['authorization/getCurrentUser'].roles && this.$store.getters['authorization/getCurrentUser'].roles.some((obj => obj.name === "Project manager"))
    },

    isSales() {
      return this.$store.getters['authorization/getCurrentUser'].roles && this.$store.getters['authorization/getCurrentUser'].roles.some((obj => obj.name === "Sales manager"))
    },

    isHr() {
      return this.$store.getters['authorization/getCurrentUser'].roles && this.$store.getters['authorization/getCurrentUser'].roles.some((obj => obj.name === "HR"))
    },

    userRole() {
      return this.$store.getters['authorization/getHrState']
        ? 'hr'
        : 'general'
    },

    isReview() {
      return !!this.$store.getters['teams/isReviewRunning']
    },

    isReviewStatusGot() {
      return this.$store.getters['teams/isReviewStatusGot']
    },

    role() {
      return this.$store.getters['authorization/getCurrentUser'].role
    },

    roles() {
      return this.$store.getters['authorization/getCurrentUser'].roles
    },


    currentUser() {
      return this.$store.getters['authorization/getCurrentUser']
    },

    currentRoleAccesses() {
      let roles = []
      if (this.$store.getters['authorization/getCurrentUser'].role_accesses) {

        this.$store.getters['authorization/getCurrentUser'].role_accesses.map((item) => {
          roles.push(item.entity)
        })

      }
      return roles

    },

    Assessment_questions() {
      return this.currentRoleAccesses.includes("Assessment_questions");
    },

    hr() {
      return this.$store.getters['authorization/getHrState']
    },

   


  },
  methods: {
    toggleModal() {
      this.$emit('toggleModal', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-link {
  cursor: pointer;
}

.iconimg {
  width: 10%;
  margin-left: 3%;
  margin-right: 8%;
  color: rgba(255, 255, 255, 0.6);
  fill: rgba(255, 255, 255, 0.6);
}

.sidebar-slider {
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 160px;
}



.nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}


.link-text {
  text-decoration: none;
}

// .router-link-exact-active .link-text {
//   text-decoration: underline;
// }

.nav-group .link-text {
  margin-left: 8px;
}
</style>

<style>
@use '@/styles/_default_table.scss' as *;

.sidebar-slider .nav-icon {
  font-size: 24px;
  color: white;
}
</style>